function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "powerlist-icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M0,0 L41.5135135,0 C52.9771537,0 62.2702703,8.90590335 62.2702703,19.8918919 C62.2702703,30.8778804 52.9771537,39.7837838 41.5135135,39.7837838 L0,39.7837838 L0,0 Z",
  id: "path-1"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "powerlist-icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "pl-icon-final",
  transform: "translate(1.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-9"
}, React.createElement("g", {
  id: "Rectangle-+-Rectangle-Mask"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Mask"
}), React.createElement("path", {
  className: "pl-icon-poly",
  d: "M1.29004377,0 L61.4054054,0 L61.4054054,0 L61.4054054,14.2702703 C61.4054054,14.9867478 60.8245856,15.5675676 60.1081081,15.5675676 L23.0990813,15.5675676 L23.0990813,15.5675676 C21.4918124,15.5675676 19.9354103,15.0568504 18.7006721,14.1242752 L1.02941935,0.777501589 C0.83884292,0.633562699 0.801035722,0.36238445 0.944974612,0.171808017 C1.02669887,0.0636043368 1.1544455,3.57975905e-16 1.29004377,0 Z",
  id: "Rectangle",
  fill: "#9FB0BB",
  mask: "url(#mask-2)"
}), React.createElement("path", {
  className: "pl-icon-poly",
  d: "M8.20804944,24.2162162 L60.1081081,24.2162162 C60.8245856,24.2162162 61.4054054,24.797036 61.4054054,25.5135135 L61.4054054,39.7837838 L61.4054054,39.7837838 L29.9975064,39.7837838 C28.3916635,39.7837838 26.8366422,39.2730666 25.6029995,38.3404914 L7.94727773,24.9936065 C7.75676276,24.8495863 7.71907134,24.5783919 7.86309158,24.3878769 C7.94482287,24.27976 8.07251611,24.2162162 8.20804944,24.2162162 Z",
  id: "Rectangle",
  fill: "#9FB0BB",
  mask: "url(#mask-2)"
})), React.createElement("path", {
  className: "pl-icon-poly",
  d: "M15.1351351,48.4324324 L43.2432432,48.4324324 L43.2432432,48.4324324 L35.5577997,62.2662308 C35.0938634,63.1013162 34.0407982,63.4021919 33.2057129,62.9382556 C33.1369367,62.9000467 33.0708477,62.8571898 33.007906,62.8099836 L14.8756757,49.2108108 C14.684615,49.0675153 14.6458937,48.7964661 14.7891892,48.6054054 C14.8708559,48.4965164 14.9990239,48.4324324 15.1351351,48.4324324 Z",
  id: "Rectangle",
  fill: "#9FB0BB"
}))));

var SvgPowerlistMenuIcon = function SvgPowerlistMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPowerlistMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/powerlist-menu-icon.9a4a9428.svg";
export { ForwardRef as ReactComponent };